<template>
    <div class="columns">
        <div class="column is-two-thirds feed-column">
            <!-- Usually empty after a trip — only renders while a post-trip
                 announcement is still recent. -->
            <today-announcements
                class="mb-6"
                :enabled="experienceEnabled"
                :posts="announcements"
                :latest-poll="latestPoll"
                :reg-id="registration.id"
                :is-staff="isStaff"
                @changed="$emit('changed')"
            />

            <div class="white-container pt-5 pb-5 has-text-centered">
                <h4 class="has-text-primary mb-2">Thanks for traveling with us!</h4>
                <p class="mb-0">We hope you had a wonderful trip. Relive it on the <router-link :to="{name: 'Experience'}">#Experience</router-link> tab.</p>
            </div>

            <media-grid
                class="mt-6"
                :media="media"
                :reg-id="registration.id"
            />

            <div class="mt-6" v-if="participants.length">
                <div class="columns is-gapless is-mobile mb-1">
                    <div class="column is-narrow">
                        <i class="fal fa-users fa-fw is-size-4 mr-3"></i>
                    </div>
                    <div class="column">
                        <h4>Fellow Travelers</h4>
                    </div>
                </div>
                <p class="has-text-grey mb-4">Stay in touch with your fellow travelers.</p>

                <div class="columns is-multiline is-mobile">
                    <div class="column is-3-widescreen is-4-tablet is-6-mobile is-flex" v-for="p in participants">
                        <participant :participant="p" small @click="gotoTraveler(p)"/>
                    </div>
                </div>
            </div>

            <!-- Mobile: teaser after the recap content. -->
            <div class="is-hidden-desktop mt-6">
                <div class="white-container pt-5 pb-5 has-text-centered">
                    <h4 class="mb-4">Your next adventure awaits!</h4>
                    <a class="button is-primary" href="https://www.tennisventures.net/programs/" target="_blank">
                        <i class="far fa-tennis-ball mr-2"></i>Explore Upcoming Trips
                    </a>
                </div>
            </div>
        </div>
        <div class="column is-one-third is-hidden-touch rail-column">
            <div class="white-container pt-5 pb-5 has-text-centered">
                <h4 class="mb-4">Your next adventure awaits!</h4>
                <a class="button is-primary" href="https://www.tennisventures.net/programs/" target="_blank">
                    <i class="far fa-tennis-ball mr-2"></i>Explore Upcoming Trips
                </a>
            </div>

            <ul class="sub-nav-menu mt-5">
                <router-link :to="{name: 'Experience'}">
                    <li><i class="far fa-hashtag fa-fw mr-3"></i>Relive the Trip</li>
                </router-link>
                <router-link :to="{name: 'Itinerary'}" v-if="trip.itinerary_visable">
                    <li><i class="far fa-calendar-alt fa-fw mr-3"></i>Trip Itinerary</li>
                </router-link>
            </ul>

            <ul class="sub-nav-menu mt-5" v-if="currentUser.registrations > 1">
                <router-link :to="{name: 'Trips'}">
                    <li><i class="far fa-tennis-ball fa-fw mr-3"></i>Choose a Different Trip</li>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import MediaGrid from '../experience/MediaGrid.vue';
    import Participant from '@/components/Participant.vue';
    import TodayAnnouncements from './TodayAnnouncements.vue';

    export default {
        name: 'TodayPostTrip',
        components: {MediaGrid, Participant, TodayAnnouncements},
        props: {
            trip: {type: Object, required: true},
            registration: {type: Object, required: true},
            announcements: {type: Array, required: true},
            latestPoll: {type: Object, default: null},
            media: {type: Array, required: true},
            participants: {type: Array, default: () => []},
            experienceEnabled: {type: Boolean, default: false},
            isStaff: {type: Boolean, default: false}
        },
        computed: {
            ...mapGetters(['currentUser'])
        },
        methods: {
            gotoTraveler: function(p) {
                this.$router.push({name: 'Traveler', params: {id: p.id}});
            }
        }
    };
</script>

<style lang="scss" scoped>
    // Same breathing room between the main column and the rail as Experience.
    @media screen and (min-width: 1024px) {
        .feed-column {
            padding-right: 2rem;
        }

        .rail-column {
            padding-left: 1rem;
        }
    }
</style>
